<script>
import View from '../../../console/src/orders/View'

export default {
  name: 'InvoiceView',

  extends: View,

  computed: {
    refundable() {
      return (
        this.orderInfo &&
        this.orderInfo.refundable &&
        this.orderInfo.category === 'custom'
      )
    },
  },

  template: '',
}
</script>
